import React from 'react';

import { useAuth } from '@cnx-saas/react-auth';
import { InjectedComponentProvider, Loading } from '@cnx-saas/common-fe';
import { availableRoutes } from './available-routes';
import AuthorizedRoutes from './authorized-routes';
import {
  useCurrentTransportsWidget,
  useDepotLoadsPieChartWidget,
  useLocationMasterDataWidget,
  useShipmentStatusCountWidget,
} from './federated-widgets';
import UnauthorizedRoutes from './unauthorized-routes';

function RoutesContainer() {
  const auth = useAuth();

  const depotLoadsPieChartWidget = useDepotLoadsPieChartWidget();
  const shipmentStatusCountWidget = useShipmentStatusCountWidget();
  const locationMasterDataWidget = useLocationMasterDataWidget();
  const currentTransportsWidget = useCurrentTransportsWidget();
  const dependencies = {
    'orderManagement/DepotLoadsPieChart': depotLoadsPieChartWidget,
    'orderManagement/LocationMasterDataWidget': locationMasterDataWidget,
    'shipmentExecution/ShipmentStatusCountWidget': shipmentStatusCountWidget,
    'shipmentExecution/CurrentTransportsWidget': currentTransportsWidget,
  };

  if (!auth.initialized) {
    return <Loading />;
  }

  if (!auth.authenticated) {
    return <UnauthorizedRoutes />;
  }

  return (
    <InjectedComponentProvider components={dependencies}>
      <AuthorizedRoutes />
    </InjectedComponentProvider>
  );
}

export { RoutesContainer, availableRoutes };
